import {
    CreateGenInfoActionTypes,
    CreateBankDetailsActionTypes,
    // CreateDifferentSourcesActionTypes,
    // GetGenInfoActionTypes,
    CreateGenInfoRequestSubmitActionTypes,
} from '../actionsTypes/index';
// import DifferentSource from '../../clientchecklist/differentSource/differentSource';

export const createGenInfoRequest = (params) => {
    //console.log('params----->GenInfoType', params);
    return {
        type: 'GenInfoType',
        payload: params,
    };
};

export const createBankDetailsRequest = (params) => {
    //console.log('params', params);
    return {
        type: 'BankDetailsType',
        payload: params,
    };
};

export const panelIndexUpdate = (params) => {
    //console.log('params', params);
    return {
        type: 'PanelIndexUpdate',
        payload: params,
    };
};

export const createIncomeTaxRequest = (params) => {
    //console.log('params', params);
    return {
        type: 'IncomeTaxType',
        payload: params,
    };
};

export const createTravelOutsideRequest = (params) => {
    //console.log('params', params);
    return {
        type: 'TravelOutsideType',
        payload: params,
    };
};

export const createDirectoryCompanyRequest = (params) => {
    //console.log('params', params);
    return {
        type: 'DirectoryCompanyType',
        payload: params,
    };
};

export const createGenInfoRequestSave = (params) => {
    //console.log('createGenInfoRequestSave', params);
    return {
        type: CreateGenInfoActionTypes.REQUEST,
        payload: params,
    };
};

export const createBankDetailsRequestSave = (params) => {
    //console.log('createBankDetailsRequestSave', params);
    return {
        type: CreateBankDetailsActionTypes.REQUEST,
        payload: params,
    };
};
export const createDifferentSourcesRequest = (params) => {
    //console.log('createDifferentSourcesRequest', params);
    return {
        type: 'DifferentSourceType',
        payload: params,
    };
};

export const getGenInfoRequest = (params) => {
    //console.log('getGenInfoRequest', params);
    return {
        type: 'GetGenInfoRequest',
        payload: params,
    };
};

export const createTotalIncomeLabelA = (params) => {
    //console.log('createTotalIncomeLabelA', params);
    return {
        type: 'CreateTotalIncomeLabelA',
        payload: params,
    };
};

export const createClientAccordian1Request = (params) => {
    //console.log('createClientAccordian1Request...params', params);
    return {
        type: 'ClientAccordian1Request',
        payload: params,
    };
};

export const createClientAccordian2Request = (params) => {
    //console.log('createClientAccordian2Request...params', params);
    return {
        type: 'ClientAccordian2Request',
        payload: params,
    };
};
export const createClientAccordian3Request = (params) => {
    //console.log('createClientAccordian3Request...params', params);
    return {
        type: 'ClientAccordian3Request',
        payload: params,
    };
};
export const createClientAccordian4Request = (params) => {
    //console.log('createClientAccordian4Request...params', params);
    return {
        type: 'ClientAccordian4Request',
        payload: params,
    };
};
export const createClientAccordian5Request = (params) => {
    //console.log('createClientAccordian5Request...params', params);
    return {
        type: 'ClientAccordian5Request',
        payload: params,
    };
};

export const createClientAccordian6Request = (params) => {
    //console.log('createClientAccordian6Request...params', params);
    return {
        type: 'ClientAccordian6Request',
        payload: params,
    };
};

export const createClientAccordian7Request = (params) => {
    //console.log('createClientAccordian7Request...params', params);
    return {
        type: 'ClientAccordian7Request',
        payload: params,
    };
};

export const createClientAccordian8Request = (params) => {
    ////console.log('createClientAccordian8Request...params', params);
    return {
        type: 'ClientAccordian8Request',
        payload: params,
    };
};

export const createClientAccordian9Request = (params) => {
    ////console.log('createClientAccordian9Request...params', params);
    return {
        type: 'ClientAccordian9Request',
        payload: params,
    };
};

export const createClientAccordian10Request = (params) => {
    ////console.log('createClientAccordian10Request...params', params);
    return {
        type: 'ClientAccordian10Request',
        payload: params,
    };
};

export const createAssestsHomeRequest = (params) => {
    ////console.log('createAssestsHomeRequest...params', params);
    return {
        type: 'CreateAssestsHome',
        payload: params,
    };
};

export const createTotalIncomeLabelB = (params) => {
    ////console.log('createTotalIncomeLabelB...params', params);
    return {
        type: 'CreateTotalIncomeLabelB',
        payload: params,
    };
};
export const createTotalIncomeLabelC = (params) => {
    ////console.log('createTotalIncomeLabelC...params', params);
    return {
        type: 'CreateTotalIncomeLabelC',
        payload: params,
    };
};
export const createTotalIncomeLabelD = (params) => {
    ////console.log('createTotalIncomeLabelD...params', params);
    return {
        type: 'CreateTotalIncomeLabelD',
        payload: params,
    };
};
export const createTotalIncomeLabelE = (params) => {
    ////console.log('createTotalIncomeLabelE...params', params);
    return {
        type: 'CreateTotalIncomeLabelE',
        payload: params,
    };
};
export const createGenInfoRequestSubmit = (params) => {
    ////console.log('createGenInfoRequestSubmit...params', params);
    return {
        type: CreateGenInfoRequestSubmitActionTypes.REQUEST,
        payload: params,
    };
};
export const crcSaveResults = (params) => {
    ////console.log('crcSaveResults...params', params);
    return {
        type: 'CRCSaveResults',
        payload: params,
    };
};

export const createAddAdditionalQue = (params) => {
    ////console.log('createAddAdditionalQue...params', params);
    return {
        type: 'CreateAddAdditionalQue',
        payload: params,
    };
};
